var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { FETCH_BULK_LABEL_DOWNLOAD_REQUEST, fetchBulkLabelDownloadFailure, fetchBulkLabelDownloadSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onFetchGetBulkLabelDownload = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.downloadLabel(`cnvt/bulk/label/${action.payload.bulkId}`, {
                file_format: action.payload.file_format
            })
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* fetchGetBulkLabelDownloadWorker(action) {
    try {
        const data = yield call(onFetchGetBulkLabelDownload, action);
        yield put(fetchBulkLabelDownloadSuccess(data));
    }
    catch (error) {
        yield put(fetchBulkLabelDownloadFailure(error));
    }
}
export function* watchGetBulkLabelDownloadData() {
    yield takeLatest(FETCH_BULK_LABEL_DOWNLOAD_REQUEST, fetchGetBulkLabelDownloadWorker);
}
